import {CloudUploadRounded} from '@mui/icons-material';
import {Grid, Typography, Button, DialogActions, styled} from '@mui/material';
import {useState} from 'react';
import {LatestUpdateType, useAddLatestUpdate} from '../../../../api/latestupdate';
import LinearProgressIndicator from '../LinearProgressIndicator';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export const AddNewMediaUpdateComponent = ({
    updateType,
    throwSnackbarMessage,
    refetch,
}: {
    updateType: LatestUpdateType;
    throwSnackbarMessage: (message: string) => void;
    refetch: VoidFunction;
}) => {
    const {addMediaLatestUpdate} = useAddLatestUpdate();
    const [uploadProgress, updateUploadProgress] = useState<number | undefined>(undefined);
    const [file, setFile] = useState<File | undefined>();

    const addingNewMediaUpdate = () => {
        if (file) {
            addMediaLatestUpdate({
                data: {
                    updateType: updateType,
                    file: file,
                    updateUploadProgress: (progress: number) => updateUploadProgress(progress),
                    cb: refetch,
                },
                throwSnackbarMessage: throwSnackbarMessage,
            });
        } else {
            throwSnackbarMessage('No file is selected');
        }
    };

    return (
        <Grid container>
            <Grid item md={12} xs={12} sm={12}>
                <Typography
                    sx={{
                        marginTop: 1,
                        fontWeight: 700,
                        color: 'black',
                        fontFamily: 'Poppins',
                    }}
                    variant='body1'>
                    Upload Text / Video
                </Typography>
            </Grid>
            <br />
            <Button
                component='label'
                role={undefined}
                variant='contained'
                tabIndex={-1}
                startIcon={<CloudUploadRounded />}>
                Upload files
                <VisuallyHiddenInput
                    type='file'
                    accept='.jpg,.jpeg,.png,.mp4'
                    onChange={(event) => {
                        if (event.target.files !== null && event.target.files?.length > 0) {
                            const newImageFile = event.target.files[0];
                            setFile(newImageFile);
                        } else {
                            throwSnackbarMessage('Please select a valid file');
                        }
                    }}
                    multiple={false}
                />
            </Button>
            {uploadProgress ? (
                <Grid container>
                    <Grid item md={5} xs={5} sm={5}>
                        <Typography
                            sx={{
                                marginTop: 1,
                                fontWeight: 700,
                                color: 'black',
                                fontFamily: 'Poppins',
                            }}
                            variant='body1'>
                            Upload progress
                        </Typography>
                        <LinearProgressIndicator progress={uploadProgress} />
                    </Grid>
                </Grid>
            ) : (
                <></>
            )}
            <br />
            <Grid container>
                <Grid item md={5} xs={5} sm={5}>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                addingNewMediaUpdate();
                            }}>
                            Save changes
                        </Button>
                        <Button onClick={() => {}}>Dismiss</Button>
                    </DialogActions>
                </Grid>
            </Grid>
        </Grid>
    );
};
